<template>
  <div class="web-manage width-full height-full flex flex-column" v-loading="loading">
    <div class="web-manage_header" style="display: inline-flex;">
      <div style="display: inline-flex;">
        <div class="web-manage__title">
          资产管理
        </div>
        <div class="web-manage_header-button">
          <w-button size="small" type="primary" plain style="width: 102px;" :disabled="!(isIndeterminate || checkAll)"
                    @click="batchAllocation(data.filter(item => item.checkbox), tab = 'batch')">批量分配到
          </w-button>
          <w-button size="small" type="primary" plain style="width: 88px;"
                    :disabled="!((isIndeterminate || checkAll) && data.filter(item => (item.checkbox && item.status === 'notUsed')).length > 0)"
                    @click="open(data.filter(item => item.checkbox && item.status !== 'notAssigned'))">批量收回
          </w-button>
        </div>
      </div>
      <div style="flex: 1;display: flex; justify-content: flex-end;">
        <w-select size="small" class="web-manage_header-select" v-model="value"
                  @change="screenAssets()">
          <w-option label="全部资产" value=""></w-option>
          <w-option label="未分配资产" value="0"></w-option>
          <w-option label="已分配资产" value="1"></w-option>
        </w-select>
        <div class="web-manage_header-input" @click="showSearch" style="margin-right: 20px;">
           <!-- --2020.9.9资产管理批量查询产品许可接口性能影响-紧急需求输入 越平邮件输入 -->
          <!-- <w-popover placement="bottom-start" trigger="click"
                     v-model="Showfirstlevel_S">
            <div style="min-height: 180px">
              <w-input
                @change="remoteMethod(query)"
                placeholder="输入产品名称搜索"
                v-model="query" size="small" style="margin-bottom: 8px">
                <i slot="prefix" class="w__input__icon r2-icon-action_search" style="font-size: 16px !important"></i>
              </w-input>
              <div v-if="options.length">
                <div v-for="(item, index) in options" :key="index" style="display: flex; line-height: 32px; width: 200px;">
                  <w-checkbox v-model="item.checked" @change="filterChange"></w-checkbox>
                  <el-tooltip>
                    <div slot="content">
                      {{item.label}}
                    </div>
                    <div class="ellipsis">{{item.label}}</div>
                  </el-tooltip>
                </div>
              </div>
              <div v-else style="min-height: 100px; width:200px;text-align: center; line-height: 20px; padding-top: 30px">
                <span>企业组织内无此产品名称<br/>请尝试其它关键词搜索</span>
              </div>
            </div>
            <div class="el-select tree-select greadSelect el-select--small el-popover__reference" slot="reference">
              <div class="el-input el-input--small el-input--suffix" style="width: 220px; height: 32px">
                <w-input type="text" readonly="readonly" autocomplete="off" size="small"
                         :placeholder="First_level_options.length>0? '':'请选择'" class="el-input__inner" >
                  <i slot="prefix" class="w__input__icon r2-icon-action_search" style="font-size: 16px !important"></i>
                  <i
                    v-if="First_level_options.length"
                    class="r2-icon-nav_cancel cursor-pointer"
                    style="line-height: 30px;"
                    slot="suffix"
                    @click="closeSearch();">
                  </i>
                </w-input>
                <div class="el-select__tags" style="width: 168px; padding-left: 12px;position: relative; top: -24px; left: 16px">
                  <span v-if="First_level_options.length" style="font-size: 14px">
                    已选择{{ First_level_options.length }}项
                  </span>
                </div>
              </div>
            </div>
          </w-popover> -->
          <!-- --2020.9.9资产管理批量查询产品许可接口性能影响-紧急需求输入 越平邮件输入 -->
          <w-input @change="search" v-model="name" type="text" autocomplete="off" size="small"
                    placeholder="请输入产品名称" class="el-input__inner" >
            <i slot="prefix" class="w__input__icon r2-icon-action_search" style="font-size: 16px !important"></i>
            <i
              class="r2-icon-nav_cancel cursor-pointer"
              style="line-height: 30px;"
              slot="suffix"
              @click="closeSearch();">
            </i>
          </w-input>
        </div>
      </div>
    </div>
    <div class="flex-1 relative border-box" style="height: calc(100% - 54px);padding: 16px 20px 0;">
      <div class="table-wrapper block flex-1 relative" id="scrollBody">
        <div class="ui-fixed tree-table fit flex flex-column table-medium table-beyond-hiding absolute height-full"
             id="tree-table">
          <div class="header-wrapper" ref="headerWrapper">
            <div class="table-header flex flex-row width-full">
              <div class="header-item is-leaf" style="background: #fff;width: 40px;padding-left: 0;"></div>
              <div class="header-item is-leaf is-center" style="background: #fff;width: 28px;padding-left: 0;">
                <w-checkbox :indeterminate="isIndeterminate"
                            v-model="checkAll"
                            @change="handleCheckAllChange"></w-checkbox>
              </div>
              <div class="header-item is-leaf flex-1" style="background: #fff;">资产编号</div>
              <div class="header-item is-leaf" style="width: 282px;background: #fff;">使用人</div>
              <div class="header-item is-leaf" style="width: 230px;background: #fff;">云锁状态</div>
              <div class="header-item is-leaf" style="width: 150px;background: #fff;" @click="sortChange()">到期时间
                <!-- <i class="sort" :class="+sortType === 0 ? 'sort-down': 'sort-up'"></i> -->
              </div>
              <div class="header-item is-leaf is-operate" style="width: 170px;background: #fff;">操作</div>
              <div class="has-gutter" v-if="scrollY"></div>
            </div>
          </div>
          <div class="body-wrapper flex-1 relative" ref="bodyWrapper" v-if="data.length">
            <div class="absolute width-full height-full">
              <w-scrollbar style="height: 100%;" wrap-style="overflow-x: hidden;">
                <ul class="container" ref="containerWrapper">
                  <template v-for="(item, index) in data">
                    <li class="flex flex-row row row--level-1 width-full" :key="`rows${index}`">
                      <div class="cell column_0 is-center" style="width:40px;">
                        <i class="r2-icon-nav_chevron_right color-default cursor-pointer"
                           :style="{transform: item.showDetails ? 'rotate(90deg)' : 'rotate(0deg)'}"
                           @click="switchPicture(item)"></i>
                      </div>
                      <div class="cell column_1 is-center" style="width:28px;padding-left: 0;">
                        <w-checkbox v-model="item.checkbox" @change="handleCheckedCitiesChange"
                                    :disabled="item.disabled"></w-checkbox>
                      </div>
                      <div class="cell column_1 flex-1">{{item.assetNum}}</div>
                      <div class="cell column_2" style="width: 282px;padding-left:16px">{{item.username}}</div>
                      <div class="cell column_3" style="width: 230px;padding-left:16px">
                        {{assetStatusMap[item.status]}}
                      </div>
                      <div class="cell column_4 is-left" style="width: 150px;padding-left:16px">{{item |
                        formatLimitEndTime}}
                      </div>
                      <div class="cell column_5 is-operate is-right" style="width: 170px;">
                        <template v-if="item.status === 'notUsed'">
                          <span class="cursor-pointer color-blue" @click="open([item], tab = 'one')">收回</span>
                          <span class="cursor-pointer color-blue" style="margin-left: 16px;" @click="allocation(item, tab = 'one')">分配到</span>
                        </template>
                        <template v-if="item.status === 'notAssigned'">
                          <span class="cursor-pointer color-blue" @click="allocation(item, tab = 'one')">分配到</span>
                        </template>
                      </div>
                    </li>
                    <li v-if="item.showDetails">
                      <div style="max-height: 268px;overflow: auto;">
                        <package-details :key="`details_${index}`" :item="item.productsDetail"></package-details>
                      </div>
                    </li>
                  </template>
                </ul>
              </w-scrollbar>
            </div>
          </div>
          <no-data v-else/>
        </div>
      </div>
    </div>
    <div class="page-box border-box" style="padding: 10px 12px 24px 20px;" v-if="total > 0">
      <w-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="pageNum"
        background
        layout="total, prev, pager, next, jumper,sizes"
        :page-size="pageSize"
        :page-sizes="[20]"
        :total="total">
      </w-pagination>
    </div>
    <!-- 批量分配弹窗 -->
    <distribution ref="dialog" :loading="loading" :assetDetailsParams="assetDetailsParams" :pageSize="pageSize" />
  </div>
</template>
<script>
// import assets from './children/assets.vue'
// import staff from './children/staff.vue'
import assetList from '@/assets/service/manage'
import {parseTime} from '@/assets/utils'
import PackageDetails from './children/PackageDetails'
import {NoData} from '@/components/common'
import distribution from './children/distribution'
import _ from 'lodash'

export default {
  name: 'asset',
  components: {
    // assets,
    // staff,
    PackageDetails,
    NoData,
    distribution
  },
  data () {
    return {
      isInitial: false,
      First_level_options: [],
      searchLoading: false,
      checked: false,
      Showfirstlevel_S: false,
      options: [], // 搜索产品列表
      query: '',
      name: '',
      productName: [], // 资产视角搜索
      pageNum: 1,
      pageSize: 20,
      total: 0,
      sortType: 0,
      value: '',
      projectName: '',
      loading: false,
      scrollY: false,
      data: [],
      // 云锁状态
      assetStatusMap: {
        online: '联网使用',
        borrow: '借出使用',
        notUsed: '未使用',
        notAssigned: '未分配'
      },
      checkAll: false, // 复选框全选状态
      isIndeterminate: false, // 选中单个之后全选框状态
      successNum: 0,
      // dialogFormVisible: false, // 批量分配弹窗
      assetDetailsParams: [] // 已选择资产列表
    }
  },
  computed: {},
  filters: {
    // 时间转换
    formatLimitEndTime (item) {
      let str = ''
      if (item.limitEndTime === null && (item.assetToDetail || []).length) {
        str = '永久'
      } else {
        if (/^\d+$/g.test(item.limitEndTime)) {
          str = parseTime(item.limitEndTime, '{y}-{m}-{d}')
        }
      }
      return str
    }
  },
  mounted () {
    // 获取资产列表
    this.postAssetList()
    // 获取员工列表
    // this.getStaffList()
    // 搜索产品名称
    // this.remoteMethod()
  },
  methods: {
    search (){
      this.productName = [this.name]
      this.postAssetList()
    },
    // 关闭搜索
    closeSearch (){
      // this.Showfirstlevel_S = false
      // this.options.forEach(item => {
      //   item.checked = false
      // })
      // this.First_level_options = []
      // this.query = ''
      // this.remoteMethod()
      this.name = ''
      this.productName = []
      this.postAssetList()
    },
    // 打开搜索
    showSearch (){
      this.Showfirstlevel_S = true
    },
    // 搜索产品名称
    remoteMethod (query = '') {
      this.searchLoading = true
      assetList.getPackagesByProductName({keyword: query}).then(res => {
        this.searchLoading = false
        if (res.code === 200) {
          const data = res.data
          let obj = {}
          for (let key in data) {
            obj[key] = data[key]
          }
          let newObj = Object.keys(obj).map(val => ({
            label: obj[val],
            value: obj[val]
          }))
          newObj.forEach(item => {
            item.checked = false
          })
          this.options = newObj
        } else {
          this.options = []
        }
      }).catch(() => {
        this.searchLoading = false
        this.options = []
      })
    },
    // 选择产品名称后，触发资产列表更新
    filterChange: _.debounce(function () {
      this.First_level_options = this.options.filter(item => item.checked)
      this.productName = this.First_level_options.map(item => item.label)
      this.loadingAssets = true
      const start = Date.now()
      this.sentLog(100117097, {message: this.productName.join(','), duration: ((Date.now() - start) / 1000).toFixed(5)})
      this.postAssetList()
    }, 500),
    // 单个分配到弹窗
    allocation (item, tab){
      this.sentLog(100117090)
      this.$refs.dialog.show(tab, item)
    },
    // 批量分配弹窗
    batchAllocation (checkbox, tab){
      this.sentLog(100117094, {number: checkbox.filter(item => item.checkbox).length})
      this.$refs.dialog.show(tab, [], checkbox)
    },
    // 改变请求
    changeGet: _.debounce(function (resetPagination = false) {
      if (resetPagination) {
        this.pageNum = 1
      }
      this.sentLog(100117099, {result: '资产视角'})
      this.postAssetList()
    }, 300),
    // 批量回收弹框
    open (item, tab) {
      this.$confirm({
        type: 'warning',
        message: '确定收回该资产吗?',
        tips: '资产收回后可以继续分配给其他员工使用',
        submitText: '确定',
        cancelText: '取消',
        width: 360,
        bodyStyle: {},
        footerStyle: {},
        submit: () => {
          let cancelConfigAssetParams = item.map(index => { return {assetNum: index.assetNum, gldUserId: index.gldUserId} })
          const list = item.map(item => { return {account: item.account, assetNum: item.assetNum} })
          this.batchRecovery(cancelConfigAssetParams, tab, list)
        }
      })
    },
    // 批量收回资产
    async batchRecovery (cancelConfigAssetParams, tab, list){
      try {
        let res = await assetList.unassign(cancelConfigAssetParams)
        if (res.code === 200){
          const data = res.data
          const start = Date.now()
          if (tab === 'one'){
            this.$nextTick(() => {
              this.sentLog(100117092, {message: list[0].assetNum + '-' + data.successList[0].account})
            })
            assetList.addRelationLog({
              area: this.userInStore.area,
              detail: `${data.successList[0].account}-${list[0].assetNum}`,
              operateType: 'ASSET_CANCEL',
              relType: '',
              showState: 1
            })
          } else {
            this.$nextTick(() => {
              this.sentLog(100117096, {number: data.successNum, duration: ((Date.now() - start) / 1000).toFixed(5)})
              let str = data.successList.map(item => { return { account: item.account, assetNum: item.assetNum} })
              let arr = ''
              for (let i = 0; i < str.length; i++) {
                arr += str[i].account + '-' + str[i].assetNum + ';'
              }
              assetList.addRelationLog({
                area: this.userInStore.area,
                detail: arr,
                operateType: 'ASSET_CANCEL_BATCH',
                relType: '',
                showState: 1
              })
            })
          }
          this.$message({
            type: 'success',
            message: `已完成 ${Math.ceil(data.successNum)} 个资产编号的收回，可重新分配`
          })
          this.postAssetList()
        } else {
          this.$message.error('资产收回失败')
        }
      } catch (e) {
        this.$message.error('资产收回失败')
      }
    },
    // 筛选不同状态资产
    screenAssets () {
      this.pageNum = 1
      this.postAssetList()
    },
    // 时间排序
    sortChange () {
      if (this.sortType === 0) {
        this.sortType = 1
      } else {
        this.sortType = 0
      }
      this.postAssetList()
    },
    // 获取资产列表
    async postAssetList () {
      try {
        this.loading = true
        let res = await assetList.postAsset({
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          sortType: this.sortType,
          assetAssignFlag: this.value
        }, this.productName)
        this.isInitial = true
        if (res.code === 200 && res.data) {
          const data = res.data || {}
          let {content = [], total = 0} = data
          content.forEach(item => {
            item.checkbox = false
            item.showDetails = false
            item.disabled = (item.status === 'borrow' || item.status === 'online')
          })
          this.data = content
          this.total = total
          this.checkAll = false
          this.isIndeterminate = false
          this.loading = false
        } else {
          this.resetStatusAndData()
        }
      } catch (e) {
        this.resetStatusAndData()
      }
    },
    // 重置loading状态跟数据
    resetStatusAndData () {
      this.loading = false
      this.data = []
      this.total = 0
    },
    // 更改页码
    handleCurrentChange (index) {
      this.pageNum = index
      this.changeGet()
    },
    // 更改页面大小
    handlePageSizeChange (index) {
      this.pageSize = index
      this.pageNum = 1
      this.changeGet()
    },
    // 全选
    handleCheckAllChange (val) {
      this.isIndeterminate = false
      this.data.forEach((item) => {
        if (item.status === 'borrow' || item.status === 'online') {
          item.checkbox = false
        } else {
          item.checkbox = val
        }
      })
    },
    // 单选改变全选状态
    handleCheckedCitiesChange () {
      let checkedCount = this.data.filter(item => item.checkbox && !item.disabled).length
      let checkedNot = this.data.filter(item => !item.disabled).length
      this.checkAll = checkedCount === checkedNot
      this.isIndeterminate = checkedCount > 0 && checkedCount < checkedNot
    },
    // 打开详情
    switchPicture (item) {
      this.sentLog(100117093)
      item.showDetails = !item.showDetails
    }
  }
}
</script>
<style lang="less" scoped>
  .web-manage {
    width: 100%;
    height: 100%;
    /*padding: 8px 20px 24px 20px;*/
    box-sizing: border-box;
  }

  .web-manage_header {
    height: 48px;
    padding: 8px 0;
    box-sizing: border-box;
    background: #FFFFFF;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
    .web-manage__title {
      font-size: 16px;
      font-weight: 600;
      color: #1F1F1F;
      line-height: 32px;
      padding: 0 20px;
    }
  }

  .web-manage_header-select {
    margin: 0 12px 0 0;
  }

  .table-wrapper {
    height: 100%;

    .role-setting {
      i {
        font-size: 12px;
      }
    }

    .w__dropdown-link {
      .more {
        cursor: pointer;

        &:hover {
          color: #1a6dcd;
        }
      }
    }
  }

  .sort {
    position: relative;
    top: 14px;
    left: 78px;
    display: inline-block;
    width: 8px;
    height: 12px;
    background: transparent url('~@/assets/images/sort.png') 0 0 no-repeat;
  }

  .sort-down {
    position: absolute;
    top: 14px;
    left: 78px;
    display: inline-block;
    width: 8px;
    height: 12px;
    background: transparent url('~@/assets/images/sort.png') -22px 0 no-repeat;
  }

  .sort-up {
    position: absolute;
    top: 14px;
    left: 78px;
    display: inline-block;
    width: 8px;
    height: 12px;
    background: transparent url('~@/assets/images/sort.png') -11px 0 no-repeat;
  }

</style>
<style lang="less" scoped>
  /deep/ .el-input__inner {
    height: 32px;
    line-height: 32px;
  }

  .tree-select {
    z-index: 111;
  }


  .el-select /deep/ .el-input__inner {
    // padding-left: 12px;
    height: 32px;
  }

  .el-select-dropdown__item.hover, .el-select-dropdown__item:hover {
    background-color: #F5F7FA;
    color: #4499FF;
  }

  .el-select-dropdown__item.selected {
    font-weight: normal;
  }
</style>
